// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"230":"811f859e","436":"7611013a"}[chunkId] + ".chunk.css";
};